import { Typography } from "@mui/material"
import { If, Else } from "lib/@components/switch"
import { EmptyValue, isEmptyValue } from "./requested-field-value-empty"

/**
 * Read-only display of a `choice` requested field's answer: the chosen option's label. Requested-field
 * options are plain strings (see `requested-field-choice-option.js`), so the stored value is itself the
 * label; we still resolve through `field.options` defensively in case a future option carries a
 * `{ value, label }` shape, falling back to the raw stored value. Counterpart of `choice-field-input.js`.
 *
 * @param {object} props
 * @param {{ id: string, options?: Array<string|{value:string,label:string}> }} props.field
 * @param {string} [props.value]
 */
export function ChoiceFieldValue({ field, value }) {
    return (
        <If value={!isEmptyValue(value)}>
            <Typography variant="body2" sx={{ wordBreak: "break-word" }}>
                {resolveLabel()}
            </Typography>
            <Else>
                <EmptyValue />
            </Else>
        </If>
    )

    function resolveLabel() {
        const options = Array.isArray(field?.options) ? field.options : []
        const match = options.find(matchesValue)
        if (match && typeof match === "object") return match.label ?? match.value ?? value
        return value
    }

    function matchesValue(option) {
        if (option && typeof option === "object") return option.value === value
        return option === value
    }
}
